import { render, staticRenderFns } from "./ProofsLibrarySelection.vue?vue&type=template&id=88b54e1c&scoped=true"
import script from "./ProofsLibrarySelection.vue?vue&type=script&lang=js"
export * from "./ProofsLibrarySelection.vue?vue&type=script&lang=js"
import style0 from "./ProofsLibrarySelection.vue?vue&type=style&index=0&id=88b54e1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b54e1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VCard,VCol,VIcon,VImg,VRow,VSheet,VSlideGroup,VSlideItem})
